import styled from 'styled-components'
import { Button } from '~components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
  max-width: 575px;
  color: ${({ theme }) => theme.neutral.text.strong};
  letter-spacing: -0.03em;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    max-width: 335px;
    padding-top: 16px;
  }
`
export const Title = styled.div`
  text-align: left;
  line-height: 140%;
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.m7};
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  margin-top: ${({ theme }) => theme.spacing.km4};
  margin-bottom: ${({ theme }) => theme.spacing.km4};
`
export const Text = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.neutral.text.default};
  margin-top: ${({ theme }) => theme.spacing.km2};
  margin-bottom: ${({ theme }) => theme.spacing.km6};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    text-align: left;
  }
`
export const HighlightedText = styled.strong`
  font-weight: ${({ theme }) => theme.font.weight.semibold};
`

export const TermsText = styled.div`
  text-align: center;
  line-height: 140%;
  color: ${({ theme }) => theme.neutral.text.default};
  font-size: ${({ theme }) => theme.font.size.m3};
  margin-bottom: ${({ theme }) => theme.spacing.km6};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    text-align: left;
  }
`

export const HighlightedTermsText = styled.span`
  color: ${({ theme }) => theme.neutral.text.default};
  font-size: ${({ theme }) => theme.font.size.m3};
  color: #c91c5b;
`

export const Link = styled.a`
  font-size: ${({ theme }) => theme.font.size.m3};
  cursor: pointer;
  color: ${({ theme }) => theme.neutral.text.default};
`
export const BottomButton = styled(Button)`
  padding-left: ${({ theme }) => theme.spacing.km10};
  padding-right: ${({ theme }) => theme.spacing.km10};
  margin-bottom: ${({ theme }) => theme.spacing.km2};
`
